import request from '@/utils/http';
const OTP = '/api-antms/billing';

// 申请单分页查询
export const getAbnormalCosts = data => {
    return request({
        url: `/api-antms/query/abnormalCost/queryPage`,
        method: 'post',
        data
    });
};

// 申请单分页查询总数量
export const getAbnormalCostsCount = data => {
    return request({
        url: `/api-antms/query/abnormalCost/queryTotal`,
        method: 'post',
        data
    });
};

// 申请单新增
export const batchInsertInsert = data => {
    return request({
        url: `${OTP}/abnormalCost/insert`,
        method: 'post',
        data
    });
};

// 申请单编辑
export const abnormalCostUpdate = data => {
    return request({
        url: `${OTP}/abnormalCost/update`,
        method: 'post',
        data
    });
};

// 申请单修改
export const batchInsertUpdate = data => {
    return request({
        url: `${OTP}/abnormalCost/batchUpdate`,
        method: 'post',
        data
    });
};

// 异常费用调整单新增接口
export const batchInsert = data => {
    return request({
        url: `${OTP}/adjustCost/batchInsert`,
        method: 'post',
        data
    });
};

// 申请单批量删除(异常费用申请单删除接口)
export const abnormalCostBatchDelete = data => {
    return request({
        url: `${OTP}/abnormalCost/batchDelete`,
        method: 'post',
        data
    });
};

// 文件删除(附件)
export const abnormalFile = id => {
    return request({
        url: `/api-antms/transport/attachment/delete?id=${id}`,
        method: 'get'
    });
};

// 文件添加(附件)
export const abnormalFileSave = data => {
    return request({
        url: `/api-antms/transport/attachment/add`,
        method: 'post',
        data
    });
};

// 发车单查询分页
export const dispatchQuery = data => {
    return request({
        url: `/api-antms/query/abnormalCost/dispatch/queryPage`,
        method: 'post',
        data
    });
};

// 发车单查询数量
export const dispatchQueryCount = data => {
    return request({
        url: `/api-antms/query/abnormalCost/dispatch/queryCount`,
        method: 'post',
        data
    });
};

// 运输单查询分页
export const transportQuery = data => {
    return request({
        url: `/api-antms/query/abnormalCost/transport/queryPage`,
        method: 'post',
        data
    });
};

// 运输单查询数量
export const transportQueryCount = data => {
    return request({
        url: `/api-antms/query/abnormalCost/transport/queryCount`,
        method: 'post',
        data
    });
};

// 运输单查询合同号、税率、商品明细
export const queryInfoByTaskNo = data => {
    return request({
        url: `/api-antms/query/abnormalCost/queryInfoByTaskNo`,
        method: 'get',
        params: data
    });
};

// 下游税率查询接口
export const querySupplierTaxRate = data => {
    return request({
        url: `${OTP}/abnormalCost/querySupplierTaxRate`,
        method: 'post',
        data
    });
};

// 上游税率查询接口
export const queryCustomerTaxRate = data => {
    return request({
        url: `${OTP}/abnormalCost/queryCustomerTaxRate`,
        method: 'post',
        data
    });
};

// 申请Id查询分摊明细
export const queryAbnormalCostById = data => {
    return request({
        url: `/api-antms/query/abnormalCost/queryAbnormalCostById`,
        method: 'get',
        params: data
    });
};

// 分摊确认
export const feeApportion = data => {
    return request({
        url: `${OTP}/abnormalCost/feeApportion`,
        method: 'post',
        data
    });
};

// 费用类型校验接口
export const checkFeeType = data => {
    return request({
        url: `${OTP}/abnormalCost/checkFeeType`,
        method: 'post',
        data
    });
};
// 异常费用申请单流程创建接口
export const iflowOrderCreateProcess = data => {
    return request({
        url: `${OTP}/iflowOrder/createAbnormalProcess`,
        method: 'post',
        data
    });
};

// 查询流程审批数据
// 通过requestId查询申请单异常计费数据
export const iflowOrderQueryAbnormalCost = params => {
    return request({
        url: `/api-antms/query/iflowOrder/query/abnormalCost?requestId=${params}`,
        method: 'get'
    });
};
// 查询申请单异常计费数据
export const iflowOrderQueryAbnormalCostDetail = data => {
    return request({
        url: `/api-antms/query/iflowOrder/query/abnormalCost/queryDetail`,
        method: 'post',
        data
    });
};
// 查询申请单异常计费数据汇总
export const iflowOrderQueryAbnormalCostDetailTotal = data => {
    return request({
        url: `/api-antms/query/iflowOrder/query/abnormalCost/queryDetailTotal`,
        method: 'post',
        data
    });
};

// 调整单流程查数据的
// 通过requestId查询调整单异常计费数据
export const iflowOrderQueryAdjustCost = params => {
    return request({
        url: `/api-antms/query/iflowOrder/query/adjustCost?requestId=${params}`,
        method: 'get'
    });
};

// 提交mip审核
export const createProcess = params => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=annto&appCode=APP202103050019`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 异常费用调整单分页查询接口(调整单详情)
export const getAdjustCosts = data => {
    return request({
        url: `/api-antms/query/adjustCost/queryPage`,
        method: 'post',
        data
    });
};
// 异常费用调整单数量查询接口(调整单详情)
export const getAdjustCostsCount = data => {
    return request({
        url: `/api-antms/query/adjustCost/queryCount`,
        method: 'post',
        data
    });
};

// 批量修改调整单金额
// 异常费用调整单新增接口
export const batchAdjustCostInsertUpdate = data => {
    return request({
        url: `${OTP}/adjustCost/batchInsert`,
        method: 'post',
        data
    });
};
// 异常费用调整单编辑接口
export const batchAdjustCostBatchUpdate = data => {
    return request({
        url: `${OTP}/adjustCost/batchUpdate`,
        method: 'post',
        data
    });
};

// 异常费用调整单流程创建接口
export const adjustIflowOrderCreateProcess = data => {
    return request({
        url: `${OTP}/iflowOrder/createAdjustProcess`,
        method: 'post',
        data
    });
};

// iflow页面查询上传文件
export const abnormalFiles = params => {
    return request({
        url: `/api-antms/transport/attachment/list`,
        method: 'get',
        params
    });
};

// 调整单删除
export const adjustCostBatchDelete = data => {
    return request({
        url: `${OTP}/adjustCost/batchDelete`,
        method: 'POST',
        data
    });
};

// iflow页面上传附件效验
export const abnormalFileCheck = params => {
    return request({
        url: `${OTP}/abnormalFile/check?requestId=${params}`,
        method: 'get'
    });
};

// 驳回直通宝申请
export const abnormalCostBatchRefuse = data => {
    return request({
        url: `${OTP}/abnormalCost/batchRefuse`,
        method: 'post',
        data
    });
};

// 台账查询接口
export const accountQuery = data => {
    return request({
        url: `/api-antms/query/fee/apply/account/query`,
        method: 'post',
        data
    });
};

// 快速提交审批
export const quickSubmitQuery = data => {
    return request({
        url: `/api-antms/query/abnormalCost/quickSubmitQuery`,
        method: 'post',
        data
    });
};

// 在线预览通用接口
export const onlineFileView = params => {
    return request({
        url: `/api-antms/common/onlineFile/view`,
        method: 'get',
        params
    });
};
